module.exports = __webpack_public_path__ + "static/media/menu-item-placeholder.4e452a23.png";